import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Config from "../../config";
import User from "../../../../services/user";
import Session from "../../../jamibet/utils/session";
import PageDataFeed from "../../../../services/page-data-feed";
import MobilePage from "../../../jamibet/utils/mobile-page";
import { CloseIconSlim } from "../../../jamibet/mobile-templates/general";
import VisibleOnHash from "../../../jamibet/utils/hash-popup";
import * as I from "../../../jamibet/utils/icons";
import { RegisterForm } from "../../../jamibet/desktop-components/user/signup-popup";
import { FormRow, HorizontalInputs, Input, InputLabel } from "../../../jamibet/desktop-components/user/login-popup";
import { MarketingEvents } from "../../../../utils/gtm-module";
import AwrabetPopupLogin, { RegisterContent as AwrabetRegisterContent } from "../../../awrabet/mobile-components/site/popup-register";
import { TelegramButton } from "../../../../services/telegram/openidLogin";
import { t } from "@lingui/macro";
import { FacebookIcon } from "../../../awrabet/utils/icons";
import { TelegramPlaneIcon } from "../../utils/icons";

export default class PopupLogin extends AwrabetPopupLogin {
	render() {
		return (
			<VisibleOnHash id="register-page" class="fixed z-10 inset-0 overflow-y-auto text-white backdrop-blur-sm" hash="#register">
				<div class="absolute top-0 right-0 w-12 p-3 fn-close" onClick={e => MobilePage.goBack()}>
					<CloseIconSlim />
				</div>
				<div class="pl-12 h-full">
					<RegisterContent />
				</div>
			</VisibleOnHash>
		);
	}
}

export class RegisterContent extends AwrabetRegisterContent {
	render() {
		return this.state.success
			? <RegisterSuccessful userInfo={this.state.userInfo} />
			: <RegisterFormMobile onFinish={userInfo => this.setState({ success: true, userInfo: userInfo })} />;
	}
}

export class RegisterSuccessful extends Component {
	render() {
		return <div class="flex flex-col gap-2 bg-harif-800 text-white">
			<div class="w-full px-2 text-center pt-3">
				<div class="px-4 pb-1 pt-3 text-lg"><Trans>Register</Trans></div>
				<div class="bg-gray-200 border flex flex-col items-center relative rounded text-base text-center text-slate-950 w-full pt-2">
					<I.CircleCheck class="h-12 text-green-600" />
					<span class="uppercase py-2"><Trans>Registration successful!</Trans></span>
					<span class="py-2 text-xs"><Trans>Close this popup to start playing</Trans></span>
				</div>
			</div>
		</div>;
	}
}

export class RegisterFormMobile extends RegisterForm {
	render({ onFinish }) {
		return <div class="flex h-full flex-col bg-harif-800 text-white">
			<div class="px-4 pb-1 pt-3 text-lg"><Trans>Register</Trans></div>
			{this.state.step == 1 ? this.renderSignup()
				: this.state.step == 2 ? this.renderOTP()
					: null}

			{!!Config.telegramLogin && <>
				<div class="relative flex justify-center px-4 pt-8 pb-2 text-center">
					<div class="absolute bottom-4 left-4 right-4 border-b"></div>
					<div class="z-0 bg-harif-800 px-4 text-sm"><Trans>Oppure</Trans></div>
				</div>
				<div class="px-4">
					<TelegramButton
						class="w-full"
						clientId={Config.telegramLogin}
						text={t`Register via Telegram`}
						shape="square"
						iconOnly={false}
						onSuccess={e => { MobilePage.closeHashPopup(); PageDataFeed.rerender(); }}
					/>
				</div>
				<div class="flex flex-col items-center gap-2 pt-3 pb-1">
					<span class="text-xs text-gray-400"><Trans>Follow us on</Trans></span>
					<div class="flex justify-center gap-3">
						<a href="https://www.facebook.com/share/1JDABF5wJv/" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-gray-300 transition-colors">
							<FacebookIcon class="w-6 h-6 fill-current" />
						</a>
						<a href="http://t.me/gojjobet" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-gray-300 transition-colors">
							<TelegramPlaneIcon class="w-6 h-6" />
						</a>
					</div>
				</div>
			</>}

			<div class="grow"></div>
			<div class="bg-harif-900 px-2 py-2">
				<div class="py-1 text-center">
					<Trans>Already have an account?</Trans> <a class="border-b border-amber-500 pb-0.5 px-0.5 text-amber-500" href="#recover-password"><Trans>Recover Password</Trans></a>
				</div>
				<div class="py-1 text-center text-sm"><Trans>You must have an account in order to place bets</Trans></div>
			</div>
		</div>;
	}

	renderSignup() {
		return <form class="fn-registration-form" ref={ref => this.form = ref} onSubmit={e => this.onSubmitSignup(e)} key="signup">
			<div class="mx-auto w-60">
				<div class="relative flex h-12 items-center justify-between text-xs">
					<div class="absolute top-6 left-0 right-0 border-b"></div>
					<div class="fn-page-indicator-1 z-0 flex h-8 w-8 items-center justify-center rounded-full border-2 bg-dark-teal transition-all border-amber-500 font-bold text-amber-500">1</div>
					<div class="fn-page-indicator-2 z-0 flex h-6 w-6 items-center justify-center rounded-full border-2 bg-dark-teal transition-all"><I.CircleCheck class="h-full scale-[1.1]" /></div>
				</div>
			</div>
			<div class="p-2 fn-register-page-1">
				<div class="mob-panel-row p-2">
					<div class="text-sm"><Trans>Number</Trans></div>
					<div class="pt-1">
						<div class="w-full rounded-sm bg-white text-black relative">
							<div class="absolute top-0 bottom-0 flex items-center text-sm pl-1.5">+251 (0)</div>
							<input required={true} class="text-inherit bg-transparent px-2 py-1 pl-14 w-full" name="username" autocomplete="tel-national" placeholder={window.Translation(msg`Number`)} />
						</div>
					</div>
				</div>
				<div class="mob-panel-row p-2">
					<div class="text-sm"><Trans>Password</Trans></div>
					<div class="pt-1">
						<input required={true} name="password" placeholder={window.Translation(msg`Password`)}
							class="w-full rounded-sm bg-white px-2 py-1 text-black disabled:bg-blue-whale-600 disabled:text-white"
							autocomplete="new-password" type="password" />
					</div>
				</div>
				<div class="mob-panel-row p-2">
					<div class="text-sm"><Trans>Confirm Password</Trans></div>
					<div class="pt-1">
						<input required={true} name="confirmPassword" placeholder={window.Translation(msg`Confirm Password`)}
							class="w-full rounded-sm bg-white px-2 py-1 text-black disabled:bg-blue-whale-600 disabled:text-white"
							autocomplete="new-password" type="password" />
					</div>
				</div>
				<div class="mob-panel-row p-2">
					<label class="block text-sm"><input type="checkbox" name="is-adult" required={true} /> <span><Trans>I confirm I'm over {21} years old</Trans></span></label>
				</div>
				{!this.state.hasError ? null : <div class="p-2">
					<div class="bg-gray-200 border py-2 relative rounded text-base text-center text-red-600 w-full">
						<div class="-top-1/3 absolute bg-red-500 border border-red-600 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
						<span>{this.state.error}</span>
					</div>
				</div>}
				<div class="px-4 py-2">
					<button type="submit" class="fn-next-btn w-full rounded bg-amber-500 py-2 text-center text-lg text-black disabled:bg-gray-500 disabled:text-black transition-all">
						<Trans>Register</Trans>
					</button>
				</div>
			</div>
		</form>;
	}

	renderOTP() {
		return <form ref={ref => this.form = ref} onSubmit={e => this.otpVerification(e)}>
			<FormRow>
				<InputLabel>OTP Code</InputLabel>
				<HorizontalInputs><Input class="grow" name="otp" required={true} /></HorizontalInputs>
			</FormRow>
			{!this.state.hasError ? null : <div class="w-full px-2 text-center pt-3 mt-2">
				<div class="bg-gray-200 border py-2 relative rounded text-base text-center text-red-600 w-full">
					<div class="-top-1/3 absolute bg-red-500 border border-red-600 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
					<span>{this.state.error}</span>
				</div>
			</div>}
			<div class="w-full px-2 text-center pt-3 mt-2">
				<button type="submit" class="w-full bg-amber-400 text-amber-950 py-2 text-center text-base font-bold uppercase hover:bg-amber-600">
					<Trans>Check OTP</Trans>
				</button>
			</div>
		</form>;
	}
}
